import * as React from 'react';

import Modal from 'react-modal';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { Dialog, DialogSet, removeModal } from 'reducers/modals';

type Props = {
  dialogs: DialogSet;
  removeModal: (dialog: Dialog) => any;
};

/* This is deprecated, please use the following:
 *
 * openModal = () => this.setState({ modal true })}
 * closeModal = () => this.setState({ modal false })}
 *
 * render() {
 *   return (
 *     <div>
 *       <button onClick={this.openModal}>
 *         click to open modal
 *       </button>
 *       <Modal isOpen={this.state.modal}>
 *         <Dialog onRequestHide={this.closeModal}>
 *           some dialog content
 *         </Dialog>
 *       </Modal>
 *     </div>
 *   );
 * }
 *
 */
class ModalsContainer extends React.Component<Props> {
  render() {
    if (this.props.dialogs.size <= 0) {
      return null;
    }

    const dialogs = this.props.dialogs.toArray().map((dialog, index) => {
      const clonedDialog = React.cloneElement(dialog, {
        onRequestHide: () => this.props.removeModal(dialog),
      });

      return (
        <Modal key={index} isOpen onRequestClose={() => this.props.removeModal(dialog)}>
          {clonedDialog}
        </Modal>
      );
    });

    return <div>{dialogs}</div>;
  }
}

function mapStateToProps(state: any) {
  return {
    dialogs: state.modals.dialogs,
  };
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return bindActionCreators({ removeModal }, dispatch);
}

export { ModalsContainer };
// @ts-ignore - ignoring new redux typing.
export default connect(mapStateToProps, mapDispatchToProps)(ModalsContainer);
